module.exports = __webpack_public_path__ + "img/watch.bca9b5c5.svg";